import { TableRoot, TableWrapper, AdditionalInfo } from './FeedingGuidelinesTable.styles'
import { useTranslation } from 'hooks/useTranslation'
import { Text } from 'components/Text'
import Trans from 'next-translate/Trans'

export const FeedingGuidelinesTable = () => {
  const { t } = useTranslation()

  return (
    <TableRoot>
      <TableWrapper>
        <thead>
          <tr>
            <th>{t('products-v2:freeze-dried-box.hero.feeding-guidelines.table.adult-weight')}</th>
            <th>{t('products-v2:freeze-dried-box.hero.feeding-guidelines.table.cups-per-day')}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{t('products-v2:freeze-dried-box.hero.feeding-guidelines.table.weights.0')}</td>
            <td>
              <Trans
                i18nKey="products-v2:freeze-dried-box.hero.feeding-guidelines.table.cups.0"
                components={{ Tiny: <Text size="caption" /> }}
              />
            </td>
          </tr>
          <tr>
            <td>{t('products-v2:freeze-dried-box.hero.feeding-guidelines.table.weights.1')}</td>
            <td>
              <Trans
                i18nKey="products-v2:freeze-dried-box.hero.feeding-guidelines.table.cups.1"
                components={{ Tiny: <Text size="caption" /> }}
              />
            </td>
          </tr>
          <tr>
            <td>{t('products-v2:freeze-dried-box.hero.feeding-guidelines.table.weights.2')}</td>
            <td>
              <Trans
                i18nKey="products-v2:freeze-dried-box.hero.feeding-guidelines.table.cups.2"
                components={{ Tiny: <Text size="caption" /> }}
              />
            </td>
          </tr>
          <tr>
            <td>{t('products-v2:freeze-dried-box.hero.feeding-guidelines.table.weights.3')}</td>
            <td>
              <Trans
                i18nKey="products-v2:freeze-dried-box.hero.feeding-guidelines.table.cups.3"
                components={{ Tiny: <Text size="caption" /> }}
              />
            </td>
          </tr>
          <tr>
            <td>{t('products-v2:freeze-dried-box.hero.feeding-guidelines.table.weights.4')}</td>
            <td>
              <Trans
                i18nKey="products-v2:freeze-dried-box.hero.feeding-guidelines.table.cups.4"
                components={{ Tiny: <Text size="caption" /> }}
              />
            </td>
          </tr>
          <tr>
            <td>{t('products-v2:freeze-dried-box.hero.feeding-guidelines.table.weights.5')}</td>
            <td>
              <Trans
                i18nKey="products-v2:freeze-dried-box.hero.feeding-guidelines.table.cups.5"
                components={{ Tiny: <Text size="caption" /> }}
              />
            </td>
          </tr>
        </tbody>
      </TableWrapper>
      <AdditionalInfo>
        <Text size="caption">
          {t('products-v2:freeze-dried-box.hero.feeding-guidelines.table.extra')}
        </Text>
      </AdditionalInfo>
    </TableRoot>
  )
}

FeedingGuidelinesTable.displayName = 'FeedingGuidelinesTable'
